import { useEffect } from "react";
import { SITE } from "./site";

const setMeta = (selector: string, content: string) => {
  const tag = document.querySelector(selector);
  if (tag) tag.setAttribute("content", content);
};

export function usePageMeta(title: string, description?: string) {
  useEffect(() => {
    document.title = title;
    setMeta('meta[property="og:title"]', title);
    setMeta('meta[name="twitter:title"]', title);
    if (description) {
      setMeta('meta[name="description"]', description);
      setMeta('meta[property="og:description"]', description);
    }
    const url = `${SITE.url}${window.location.pathname}`;
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute("href", url);
    setMeta('meta[property="og:url"]', url);
  }, [title, description]);
}
